import { HStack, VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { TextVariant } from "@/components/Typography/Text.variant";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import type { AppUser } from "@/features/app-user/types";
import { genNameInitials } from "@/utils/name";

const AppUserAvatar = ({ appUser }: { appUser: AppUser }) => (
  <HStack className="gap-3 items-center">
    <Avatar className="w-10 h-10 bg-muted">
      <AvatarImage className="object-contain" src={appUser.avatarUrl} />
      <AvatarFallback>{genNameInitials(appUser.name || "")}</AvatarFallback>
    </Avatar>
    <VStack className="gap-1 flex-1 min-w-0">
      <Text variant={TextVariant.labelReg} className="line-clamp-1">
        {appUser.name}
      </Text>
      <Text
        variant={TextVariant.labelSmallReg}
        className="line-clamp-1 text-muted-foreground"
      >
        {appUser.email}
      </Text>
    </VStack>
  </HStack>
);

export default AppUserAvatar;
